/* ============================================================================
   FORWRD · Player Advantage pricing
   ----------------------------------------------------------------------------
   1. Reads Shopify's discount_code cookie (set by /discount/CODE links).
      PLAYER24-... = 24-hour tier, PLAYER-10-... = standard tier (prefixes
      come from theme settings). Any other code is ignored here.
   2. Fills [data-pp] price lists (collection cards, PDP) with the discounted
      price and label, and flags them .pp-on. html.pp-active hides the
      "Get Player Pricing" buttons.
   3. Buttons open the Klaviyo form (mobile or desktop ID).
   4. Once the cart has items, makes sure the code is on the cart and reads the
      real percentage back from Shopify, correcting the displayed price.
   The cart drawer itself is rendered server-side in snippets/line-item.liquid.
   Config: window.FW_PP, from snippets/player-pricing-head.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.FW_PP;
  if (!CFG) return;

  var KEY = 'fw_pp';
  var IGNORE_KEY = 'fw_pp_ignore';
  var DAY = 864e5;
  var html = document.documentElement;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var state = null;

  /* ---------- storage / cookie helpers ---------- */

  function lsGet(k) {
    try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; }
  }

  function lsSet(k, v) {
    try {
      if (v == null) localStorage.removeItem(k);
      else localStorage.setItem(k, JSON.stringify(v));
    } catch (e) {}
  }

  function norm(code) { return String(code || '').trim().toUpperCase(); }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function tierOf(code) {
    code = norm(code);
    var p24 = norm(CFG.prefix24);
    var pStd = norm(CFG.prefixStd);
    if (p24 && code.indexOf(p24) === 0) return '24h';
    if (pStd && code.indexOf(pStd) === 0) return 'std';
    return null;
  }

  function isIgnored(code) { return (lsGet(IGNORE_KEY) || []).indexOf(norm(code)) > -1; }

  function ignore(code) {
    code = norm(code);
    if (!code) return;
    var list = lsGet(IGNORE_KEY) || [];
    if (list.indexOf(code) < 0) {
      list.push(code);
      lsSet(IGNORE_KEY, list.slice(-20));
    }
  }

  /* ---------- state ---------- */

  function makeState(code, src) {
    var tier = tierOf(code);
    return {
      code: norm(code),
      tier: tier,
      pct: tier === '24h' ? Number(CFG.pct24) : Number(CFG.pctStd),
      // 24-hour codes stop displaying 24h after first seen on this device.
      exp: Date.now() + (tier === '24h' ? DAY : 30 * DAY),
      src: src
    };
  }

  function setState(s) {
    state = s;
    lsSet(KEY, s);
    paint();
  }

  function resolve() {
    var stored = lsGet(KEY);
    var cookie = norm(getCookie('discount_code'));

    if (stored && (!stored.code || stored.exp <= Date.now())) {
      ignore(stored.code);
      stored = null;
      lsSet(KEY, null);
    }

    if (cookie && tierOf(cookie) && !isIgnored(cookie)) {
      state = (stored && stored.code === cookie) ? stored : makeState(cookie, 'cookie');
      // Until the cart confirms the real value, always use the current theme setting,
      // so a settings change (e.g. 15% to 20%) applies to visitors who already have a code.
      if (!state.verified) {
        state.pct = state.tier === '24h' ? Number(CFG.pct24) : Number(CFG.pctStd);
      }
      lsSet(KEY, state);
    } else if (stored && stored.src === 'cookie') {
      // Cookie gone or replaced (order placed, code removed, different code): stop showing.
      state = null;
      lsSet(KEY, null);
    } else {
      state = stored;
    }

    paint();
  }

  /* ---------- money ---------- */

  function formatMoney(cents) {
    var fmt = String(CFG.moneyFormat || '${{amount}}');
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);

    function num(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }

    if (!match) return '$' + num(2, ',', '.');

    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(2, "'", '.'); break;
      default: value = num(2, ',', '.');
    }

    return fmt.replace(match[0], value).replace(/&amp;/g, '&');
  }

  /* ---------- rendering ---------- */

  function renderPrice(el) {
    var slot = el.querySelector('[data-pp-applied]');
    if (!slot) return;

    var cents = parseInt(el.getAttribute('data-pp-price'), 10) || 0;
    var eligible = !!state && cents > 0 &&
      el.getAttribute('data-pp-min-ok') === '1' &&
      (state.tier !== '24h' || el.getAttribute('data-pp-24') === '1');

    var key = eligible ? [cents, state.pct, state.tier].join('|') : 'off';
    if (el.getAttribute('data-pp-key') === key) return;
    el.setAttribute('data-pp-key', key);
    el.classList.toggle('pp-on', eligible);

    if (!eligible) {
      slot.textContent = '';
      return;
    }

    var finalCents = cents - Math.round(cents * state.pct / 100);

    var price = document.createElement('span');
    price.className = 'pp-applied__price';
    price.textContent = (el.hasAttribute('data-pp-from') && CFG.fromLabel ? CFG.fromLabel + ' ' : '') + formatMoney(finalCents);

    var label = document.createElement('span');
    label.className = 'pp-applied__label';
    label.textContent = state.tier === '24h' ? CFG.label24 : CFG.label;

    slot.replaceChildren(price, label);
  }

  function paint() {
    var active = !!state;
    html.classList.toggle('pp-active', active);
    html.classList.toggle('pp-24h', active && state.tier === '24h');

    var els = document.querySelectorAll('[data-pp]');
    for (var i = 0; i < els.length; i++) renderPrice(els[i]);
  }

  // Variant changes and drawer/quick-view re-renders swap price markup in;
  // paint any new [data-pp] nodes.
  var queued = false;

  function queuePaint() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      paint();
    });
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.hasAttribute('data-pp') || node.querySelector('[data-pp]'))) {
          queuePaint();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- Klaviyo form ---------- */

  function openForm() {
    var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var id = mobile ? CFG.formMobile : CFG.formDesktop;
    if (!id) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-pp-open]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    openForm();
  }, true);

  /* ---------- cart sync ---------- */

  var applyTried = {};
  var verifyTimer = null;

  function findApplication(cart, code) {
    var hit = null;

    (cart.cart_level_discount_applications || []).forEach(function (app) {
      if (norm(app.title) === code) hit = app;
    });

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var app = alloc.discount_application;
        if (app && norm(app.title) === code) hit = app;
      });
    });

    return hit;
  }

  function applyToCart(code) {
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (res) {
      if (!res.ok) return;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      scheduleVerify(800);
    }).catch(function () {});
  }

  function verifyCart() {
    fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];

        // Browsers that can't read the cookie: adopt a Player code already on the cart.
        if (!state) {
          for (var i = 0; i < codes.length; i++) {
            if (tierOf(codes[i].code) && !isIgnored(codes[i].code)) {
              setState(makeState(codes[i].code, 'cart'));
              break;
            }
          }
          if (!state) return;
        }

        if (!cart.item_count) return;

        var onCart = codes.some(function (c) { return norm(c.code) === state.code; });

        if (!onCart) {
          // Only add ours if the customer has no other code on the cart.
          if (!codes.length && !applyTried[state.code]) {
            applyTried[state.code] = true;
            applyToCart(state.code);
          }
          return;
        }

        // Correct the displayed percentage to what Shopify actually applies.
        var app = findApplication(cart, state.code);
        if (app && app.value_type === 'percentage') {
          var pct = parseFloat(app.value);
          if (pct > 0 && pct < 100 && (pct !== state.pct || !state.verified)) {
            state.pct = pct;
            state.verified = true;
            setState(state);
          }
        }
      })
      .catch(function () {});
  }

  function scheduleVerify(delay) {
    clearTimeout(verifyTimer);
    verifyTimer = setTimeout(verifyCart, delay || 0);
  }

  html.addEventListener('cart:change', function () { scheduleVerify(400); });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) resolve();
  });

  resolve();
  scheduleVerify(1200);
})();
